export const ROTATE_SHELL_MAX_WIDTH = 640;

export const ROTATED_SHELL_MEDIA_QUERY =
  `(max-width: ${ROTATE_SHELL_MAX_WIDTH}px) and ` +
  "(orientation: portrait) and (hover: none) and (pointer: coarse)";

export const COMPACT_ROTATED_LAYOUT_MEDIA_QUERY =
  `(max-width: 950px) and (max-height: 480px), ${ROTATED_SHELL_MEDIA_QUERY}`;

export const isRotatedShellViewport = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia(ROTATED_SHELL_MEDIA_QUERY).matches;
};
